import type { MutableRefObject } from "react";

export function clearWindowTimer(timerRef: MutableRefObject<number | null>) {
  if (!timerRef.current || typeof window === "undefined") return;
  window.clearTimeout(timerRef.current);
  timerRef.current = null;
}
